import { render, staticRenderFns } from "./FirstQuestion.vue?vue&type=template&id=0bb79162&"
import script from "./FirstQuestion.vue?vue&type=script&lang=js&"
export * from "./FirstQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb79162')) {
      api.createRecord('0bb79162', component.options)
    } else {
      api.reload('0bb79162', component.options)
    }
    module.hot.accept("./FirstQuestion.vue?vue&type=template&id=0bb79162&", function () {
      api.rerender('0bb79162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/TranferFAQ/FirstQuestion.vue"
export default component.exports